export enum ParseQuotationType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum FreightType {
  CIF = 'CIF',
  FOB = 'FOB',
}
